export class RestoreGoogleWorkspaceRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "files",
            "baseName": "files",
            "type": "Array<FilePath>",
            "format": ""
        },
        {
            "name": "selection",
            "baseName": "selection",
            "type": "WorkspaceRestoreSelection",
            "format": ""
        },
        {
            "name": "restoreMode",
            "baseName": "restoreMode",
            "type": "WorkspaceRestoreMode",
            "format": ""
        },
        {
            "name": "restoreTargetFolder",
            "baseName": "restoreTargetFolder",
            "type": "string",
            "format": ""
        },
        {
            "name": "preserveFolderHierarchy",
            "baseName": "preserveFolderHierarchy",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "restoreTargetMailboxes",
            "baseName": "restoreTargetMailboxes",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "restoreTargetLabel",
            "baseName": "restoreTargetLabel",
            "type": "string",
            "format": ""
        },
        {
            "name": "restoreOriginalLabels",
            "baseName": "restoreOriginalLabels",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "isGroup",
            "baseName": "isGroup",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "restoreTargetGroup",
            "baseName": "restoreTargetGroup",
            "type": "string",
            "format": ""
        },
        {
            "name": "restoreTargetDrive",
            "baseName": "restoreTargetDrive",
            "type": "string",
            "format": ""
        },
        {
            "name": "groupRestoreScope",
            "baseName": "groupRestoreScope",
            "type": "GoogleWorkspaceGroupRestoreScope",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreGoogleWorkspaceRequest.attributeTypeMap;
    }
    constructor() {
    }
}
